import { RunContextApp } from "framework/RCApp"
import { CONTENT_VERIFICATION_STATUS, QA_WORKFLOW, WORKFLOW_STATE, CONTENT_EDIT_ACTION } from "types/cms/frontendTypes"

export const VerificationWorkflowUtils = {

  getNextWorkflowState : (rc : RunContextApp,
                          currentQaStatus : CONTENT_VERIFICATION_STATUS, 
                          reviewWorkflow : QA_WORKFLOW) : WORKFLOW_STATE => {
    
   const userRole = rc.permissionsManager.getUserRole()

    // Filter edges for user role
    const filteredWorkflow = reviewWorkflow.filter((wf) => {
      return wf.userRoles.includes(userRole)
    })

    if (!filteredWorkflow || filteredWorkflow.length === 0) {
      throw new Error(`No workflow found for user role ${userRole}`)
    }

    const workflow = filteredWorkflow[0]
    const actions = workflow.actions[currentQaStatus]

    const edges = workflow.qaWorkflowEdges

    const graph = {} as Record<CONTENT_VERIFICATION_STATUS, CONTENT_VERIFICATION_STATUS[]>

    for (const edge of edges) {
      const from = edge.from
      const to = edge.to
      
      if (!graph[from]) {
        graph[from] = []
      }

      graph[from].push(to)
    }

    return {
      nextQaStatus : graph[currentQaStatus] || [],
      actions : actions
    }
  },

  isActionAllowed : (action : CONTENT_EDIT_ACTION, 
                     workflowState : WORKFLOW_STATE) : boolean => {
    
    return workflowState.actions.includes(action)
  }

}